<template>
  <section class="top-0 bg-gray-100 shadow-md mb-8">
    <!-- z-10 -->
    <div class="container mx-auto px-4 lg:px-16">
      <div class="lg:divide-y lg:divide-gray-200">
        <div class="relative h-16 flex justify-between">
          <div class="flex items-center w-full space-x-6">
            <!-- z-10 -->
            <div class="relative px-2 flex lg:px-0 w-full">
              <div
                class="absolute inset-y-0 left-0 flex items-center sm:hidden"
                v-click-outside="handleIsMenuOpen"
              >
                <!-- Mobile menu button -->
                <button
                  type="button"
                  class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                  aria-controls="mobile-menu"
                  aria-expanded="false"
                  @click.prevent="toggleMenuOpen"
                >
                  <span class="sr-only">Open main menu</span>
                  <svg
                    class="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div>
              <div
                class="flex-1 flex items-center sm:items-stretch sm:justify-start md:px-0 px-8"
              >
                <div
                  class="flex-shrink-0 flex items-center duration-500 rounded-lg"
                >
                  <router-link :to="{ name: 'dashboard' }">
                    <img
                      class="block h-8 w-auto"
                      :src="require(`@/assets/img/fitclas.png`)"
                      alt="Workflow"
                    />
                  </router-link>
                  <router-link
                    :to="{ name: 'dashboard', params: { id: 'all' } }"
                    class="ml-5 xl:ml-10 text-base hover:text-green-light"
                    exact-active-class="text-green-dark"
                  >
                    Dashboard
                  </router-link>
                  <router-link
                    :to="{ name: 'sessions', params: { id: 'all' } }"
                    class="ml-5 xl:ml-10 text-base hover:text-green-light"
                    exact-active-class="text-green-dark"
                  >
                    Class template
                  </router-link>
                  <router-link
                    :to="{ name: 'EarningsOverview' }"
                    class="ml-5 xl:ml-10 text-base hover:text-green-light"
                    exact-active-class="text-green-dark"
                  >
                    Reports
                  </router-link>
                  <!--
                  <router-link
                    :to="{ name: 'music' }"
                    class="ml-5 xl:ml-10 text-base hover:text-green-light"
                    exact-active-class="text-green-dark"
                  >
                    Music
                  </router-link>
                  -->
                </div>
              </div>
            </div>

            <div
              class="inset-y-0 right-0 flex items-center pr-8 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
              v-if="getToken()"
            >
              <!-- Calendar dropdown -->
              <div
                class="flex-shrink-0 relative ml-4 w-8 h-8"
                v-click-outside="toggleCalendarDropdown"
              >
                <div>
                  <!-- tooltip -->
                  <button
                    type="button"
                    class="hover:text-green-light bg-transparent p-1 rounded-full text-gray-dark focus:outline-none flex"
                    @click="isCalendarOpen = !isCalendarOpen"
                  >
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <Calendar class="user-calendar" slot="reference" />
                      <span class="popper"> Calendar </span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right z-20 absolute right-0 mt-2 md:w-96 w-64 rounded-md shadow-lg bg-white ring-gray-300 ring-opacity-5 focus:outline-none ring-1"
                  v-if="isCalendarOpen"
                >
                  <MiniCalendar :type="'trainer'" class="mini-calendar" />
                  <div class="flex justify-center items-center uppercase">
                    <router-link
                      :to="{ name: 'TrainerCalendar' }"
                      class="w-full h-10 px-6 text-white transition-colors duration-150 bg-green-light rounded-b-lg focus:shadow-outline text-center py-2"
                    >
                      Open Calendar
                    </router-link>
                  </div>
                </div>
              </div>

              <!-- Chat notification dropdown -->
              <div
                class="flex-shrink-0 relative ml-4 w-8 h-8"
                v-click-outside="toggleChat"
              >
                <div>
                  <!-- tooltip -->
                  <button
                    type="button"
                    class="hover:text-green-light bg-transparent p-1 rounded-full text-gray-dark focus:outline-none flex"
                    @click="isChatOpen = !isChatOpen"
                  >
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <ChatAlt
                        :badge="isChatIconActive"
                        :value="sendMessageSum"
                        slot="reference"
                      />
                      <span class="popper"> Chat </span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 md:w-96 w-72 rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 py-1 focus:outline-none border"
                  v-if="isChatOpen"
                >
                  <ChatNotificationDropdown
                    :userType="'Trainer'"
                    @onClose="toggleChat"
                  />
                </div>
              </div>

              <!-- Notification dropdown -->
              <div
                class="flex-shrink-0 relative ml-4 w-8 h-8"
                v-click-outside="closeNotification"
              >
                <div>
                  <!-- tooltip -->
                  <button
                    type="button"
                    class="hover:text-green-light bg-transparent p-1 rounded-full text-gray-dark focus:outline-none flex"
                    @click="toggleNotificationDropdown"
                  >
                    <span class="sr-only">View notifications</span>
                    <!-- Heroicon name: outline/bell -->
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <Bell
                        :badge="isBellIconActive"
                        :value="joinSessionSum"
                        slot="reference"
                      />
                      <span class="popper"> Notifications </span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 md:w-96 w-72 rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 py-1 focus:outline-none border"
                  v-if="isNotificationOpen"
                >
                  <NotificationDropdown
                    :userType="'Trainer'"
                    @onClose="closeNotification"
                  />
                </div>
              </div>
              <!-- Fitclass tutorials Icon -->
              <div
                v-if="tutorialPath && tutorialPath.length && tutorialPath !== 'undefined'"
                class="flex-shrink-0 relative ml-3 w-8 h-10"
              >
                <!-- tooltip -->
                <button
                  type="button"
                  class="hover:text-green-light bg-transparent p-1 rounded-full text-gray-dark focus:outline-none flex"
                  @click="redirectUrlHandler"
                >
                  <Tooltip
                    trigger="hover"
                    :options="{
                      placement: 'bottom',
                      modifiers: { offset: { offset: '0,2px' } },
                    }"
                    :forceShow="displayTurialNotifier"
                    rootClass="tutorial-popper"
                  >
                    <i class="fa fa-question-circle-o text-2xl" slot="reference"></i>
                    <span class="popper"> {{tutorialText}} </span>
                  </Tooltip>
                </button>
              </div>
              <!-- Profile dropdown -->
              <div
                class="flex-shrink-0 relative ml-4 w-8 h-8"
                v-click-outside="hideIsProfileOpen"
              >
                <div>
                  <!-- tooltip -->
                  <button
                    type="button"
                    class="hover:text-green-light bg-white rounded-full flex focus:outline-none"
                    @click="toggleProfileDropdown"
                  >
                    <span class="sr-only">Open user menu</span>
                    <Tooltip
                      trigger="hover"
                      :options="{
                        placement: 'bottom',
                        modifiers: { offset: { offset: '0,2px' } },
                      }"
                    >
                      <img
                        class="h-8 w-8 rounded-full"
                        :src="baseUrlSrc(getTrainerImage)"
                        alt=""
                        @error="defaultCircleImage"
                        slot="reference"
                      />
                      <span class="popper">Profile</span>
                    </Tooltip>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-gray-300 ring-opacity-5 focus:outline-none z-10"
                  v-if="isProfileOpen"
                >
                  <router-link
                    :to="{ name: 'TrainerProfileAbout' }"
                    class="hover:bg-gray-200 block px-4 py-2 text-sm text-gray-700"
                  >
                    Your Profile
                  </router-link>
                  <router-link
                    :to="{ name: 'TrainerSettings' }"
                    class="hover:bg-gray-200 block px-4 py-2 text-sm text-gray-700"
                  >
                    Settings
                  </router-link>
                  <a
                    href="javascript:void(0)"
                    class="block hover:bg-gray-200 px-4 py-2 text-sm text-gray-700"
                    @click="logoutHandler"
                  >
                    Sign out
                  </a>
                </div>
              </div>
              <!--
              <div class="relative ml-8" v-click-outside="onoutsideAsTrainer">
                <button
                  class="inline-flex items-center h-10 px-3 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none hover:bg-white ring-1 ring-gray-400 w-44 justify-center"
                  @click="onclickAsTrainer"
                >
                  <span>Seen as Trainer</span>
                  <svg class="w-4 h-4 ml-3 fill-current" viewBox="0 0 20 20">
                    <path
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                    ></path>
                  </svg>
                </button>
                <div
                  class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-400 ring-opacity-5 focus:outline-none"
                  v-if="isAsTrainer"
                >
                  <div class="py-1">
                    <a
                      href="#"
                      class="text-gray-700 block px-4 py-2 text-sm bg-gray-100"
                    >
                      Seen as Trainer
                    </a>
                    <button
                      type="button"
                      class="text-gray-700 block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                      @click="switchToUserProfile"
                    >
                      Seen as Attendee
                    </button>
                  </div>
                </div>
              </div>
              -->
              <UserRoleSelector v-if="getUser().isRoleSelected===true"></UserRoleSelector>
            </div>
            <!-- absolute -->
            <div
              class="inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 space-x-4"
              v-else
            >
              <router-link
                :to="{ name: 'SessionsFind' }"
                class="text-sm text-gray-dark md:block hidden"
              >
                Explore
              </router-link>
              <router-link
                :to="{ name: 'Register' }"
                class="text-sm text-gray-dark w-32 md:block hidden"
              >
                Become a Trainer
              </router-link>
              <router-link
                :to="{ name: 'Login' }"
                class="flex-shrink-0 bg-green-light rounded-md py-2 px-5 text-white hover:text-gray-100 focus:outline-none hover:shadow-lg"
              >
                Login
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex items-center justify-between px-28"
      v-if="TRAINERROUTES.includes($route.name)"
    >
      <scrollactive
        active-class="border-b-2"
        :offset="125"
        class="hidden lg:py-0 lg:flex lg:space-x-8"
        aria-label="Global"
      >
        <a
          href="#trainer"
          data-section-selector="#trainer"
          class="scrollactive-item border-transparent text-gray-dark whitespace-nowrap py-4 px-0 border-black font-normal text-sm"
        >
          Trainer
        </a>

        <a
          href="#"
          class="scrollactive-item border-transparent text-gray-dark whitespace-nowrap py-4 px-0 border-black font-normal text-sm"
        >
          ClassLive
        </a>
      </scrollactive>

      <div class="flex items-center space-x-2">
        <button
          type="button"
          class="ring-1 ring-gray-300 p-1 text-gray-light rounded-md focus:bg-green-light focus:text-white focus:outline-none"
          title="Share link"
          @click.prevent="handleShareButton"
        >
          <!-- Share icon -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            viewBox="0 0 33 31"
          >
            <g id="noun_Share_4241699" transform="translate(-0.542 -1.899)">
              <g id="Layer_10" data-name="Layer 10">
                <path
                  id="Path_2127"
                  data-name="Path 2127"
                  d="M27.9,2.682a.881.881,0,0,0-.51-.276c-.013,0-.023-.007-.036-.007s-.024.007-.037.007a.677.677,0,0,0-.7.69v3.91c-2.219-.142-6.786.172-8.77,4.682C15.108,17.9,18.912,24.1,19.075,24.36a.7.7,0,0,0,.591.328.687.687,0,0,0,.144-.015.7.7,0,0,0,.546-.582c.812-5.616,3.957-8.089,6.262-9.161V20.1a.7.7,0,0,0,1.154.527L37.607,12.1a.7.7,0,0,0,0-1.056Zm.109,15.89v-4.68a.7.7,0,0,0-.93-.658,12.008,12.008,0,0,0-7.691,8.615c-.876-2.142-1.891-5.921-.268-9.6,1.434-3.259,4.494-3.883,6.624-3.883.331,0,.635.016.912.038v.737a.7.7,0,0,0,1.395,0V4.655l8.03,6.923Z"
                  transform="translate(-4.806)"
                  stroke="#222"
                  stroke-width="1"
                />
                <path
                  id="Path_2128"
                  data-name="Path 2128"
                  d="M30.256,19.866a.7.7,0,0,0-.7.694v5.931a4.7,4.7,0,0,1-4.7,4.685H7.138a4.7,4.7,0,0,1-4.7-4.685V9.019a4.7,4.7,0,0,1,4.7-4.685h7.89a.694.694,0,1,0,0-1.389H7.138a6.092,6.092,0,0,0-6.1,6.074V26.491a6.092,6.092,0,0,0,6.1,6.074H24.857a6.092,6.092,0,0,0,6.1-6.074V20.56a.7.7,0,0,0-.7-.694Z"
                  transform="translate(0 -0.165)"
                  stroke="#222"
                  stroke-width="1"
                />
              </g>
            </g>
          </svg>
        </button>
      </div>
    </div>
    <Modal v-model="isShareModalOpen" :title="'Share link to Class'">
      <div class="space-y-4">
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share link via</p>
          <ShareNetworkComponent :sharingUrl="sharingUrl" />
        </div>
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share this link</p>
          <div class="flex items-center">
            <input
              class="w-full h-10 px-3 text-base text-gray-700 placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
              type="text"
              placeholder="Sharing url"
              v-model="sharingUrl"
              disabled
            />
            <button
              type="button"
              class="h-10 px-4 text-sm text-green-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light w-32"
              id="copy-url"
              @click.prevent="handleCopyUrlButton"
            >
              Copy URL
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script>
import MiniCalendar from "@/components/MiniCalendar.vue";

import ChatNotificationDropdown from "@/components/notification/ChatNotificationDropdown";
import ShareNetworkComponent from "@/components/social-sharing/ShareNetworkComponent";
import NotificationDropdown from "@/components/notification/NotificationDropdown";
import { Bell, Calendar, ChatAlt } from "@/components/icons";
import { Modal } from "@/components/t-components";
import { mapActions, mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import Tooltip from "@/components/Tooltip.vue";
import UserRoleSelector from "./UserRoleSelector.vue";

export default {
  name: "TrainerHeader",
  components: {
    Bell,
    Modal,
    Calendar,
    ChatAlt,
    NotificationDropdown,
    ShareNetworkComponent,
    ChatNotificationDropdown,
    MiniCalendar,
    Tooltip,
    UserRoleSelector
},
  props: {
    data: Array,
  },
  data() {
    return {
      isMenuOpen: false,
      isProfileOpen: false,
      isCalendarOpen: false,
      // details: JSON.parse(localStorage.getItem("details")),
      isNotificationOpen: false,
      isChatOpen: false,
      joinSessionSum: 0,
      sendMessageSum: 0,
      isChatIconActive: false,
      isBellIconActive: false,
      isShareModalOpen: false,
      sharingUrl: "",
      tutorialText: 'Tutorials',
      displayTurialNotifier: false
      // isAsTrainer: false,
    };
  },
  computed: {
    ...mapGetters(["notifications", "categoriesList", "trainerProfile", 'tutorialNotified']),
    getTrainerImage () {
      return this.trainerProfile && this.trainerProfile.profile && this.trainerProfile.profile.thumbnail_url
    },
    tutorialPath () {
      return window.config.VUE_APP_TRAINER_TUTORIAL_URL
    }
  },
  methods: {
    ...mapActions([
      "getNotifications",
      "logout",
      "switchToUser",
      "getCategoriesList",
    ]),

    logoutHandler() {
      this.$store.commit("setIsLoading", true);
      this.logout()
    },

    // async switchToUserProfile() {
    //   store.commit("setIsLoading", true);
    //   try {
    //     await this.switchToUser();
    //     let user = JSON.parse(localStorage.getItem("user"));
    //     user.user_type = 1;
    //     localStorage.setItem("user", JSON.stringify(user));
    //     this.$router.push({ name: "Newhome" });
    //   } catch {
    //     console.log("Can't switch to Attendee profile");
    //   }
    //   store.commit("setIsLoading", false);
    // },

    toggleProfileDropdown() {
      this.isProfileOpen = !this.isProfileOpen;
    },

    hideIsProfileOpen() {
      this.isProfileOpen = false;
    },

    toggleCalendarDropdown() {
      this.isCalendarOpen = false;
    },

    toggleMenuOpen() {
      this.isMenuOpen = !this.isMenuOpen;
      this.$emit("is-menu-open", this.isMenuOpen);
    },

    handleIsMenuOpen() {
      this.isMenuOpen = false;
      // this.$emit("is-menu-open", this.isMenuOpen);
    },

    toggleNotificationDropdown() {
      this.isNotificationOpen = !this.isNotificationOpen;
    },

    closeNotification() {
      this.isNotificationOpen = false;
    },

    toggleChat() {
      this.isChatOpen = false;
    },

    sumNotifications() {
      this.notifications &&
        this.notifications.forEach((el) => {
          if (el.type == "joinSession") {
            this.joinSessionSum += el.is_active;
          } else if (el.type == "sendMessage") {
            this.sendMessageSum += el.is_active;
          } else {
            // console.log("else");
          }
        });

      if (this.joinSessionSum) {
        this.isBellIconActive = true;
      }
      if (this.sendMessageSum) {
        this.isChatIconActive = true;
      }
    },

    async handleShareButton() {
      this.isShareModalOpen = !this.isShareModalOpen;
      this.sharingUrl = this.getRouterHref(this.USERSESSIONLIVE);
    },

    handleCopyUrlButton() {
      if (this.sharingUrl) {
        navigator.clipboard.writeText(this.sharingUrl);
        document.getElementById("copy-url").innerHTML = "Copied";
      }
    },
    redirectUrlHandler () {
      localStorage.setItem("fitclass_tutorialAct", 'visited');
      window.open(
        this.tutorialPath,
        '_blank'
      );
    },
    checkTutorialNotifier () {
      let userTutorialAct = localStorage.getItem("fitclass_tutorialAct");
      if (!userTutorialAct && !this.tutorialNotified) {
        this.tutorialText = 'Looking for Fitclass Tutorials ?'
        this.displayTurialNotifier = true
        setTimeout(() => {
          this.displayTurialNotifier = false
          this.tutorialText = 'Tutorials'
          this.$store.commit('setTutorialNotifier', true)
        }, 5000);
      }
    }
    // onoutsideAsTrainer() {
    //   this.isAsTrainer = false;
    // },

    // onclickAsTrainer() {
    //   this.isAsTrainer = !this.isAsTrainer;
    // },
  },
  async created() {
    this.checkTutorialNotifier()
    if (this.getToken()) {
      this.trainerProfile && Object.keys(this.trainerProfile).length ? '' : await this.$store.dispatch('getTrainerProfile');
      await this.getNotifications();
    }
    this.sumNotifications();
    await this.getCategoriesList();
  },
  directives: {
    ClickOutside,
  }
};
</script>

<style>
/* .tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%; At the top of the tooltip
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
} */
.fc-button.fc-button-primary {
  padding: 1px 14px;
  text-transform: capitalize !important;
  background-color: white !important;
  color: black !important;
}
.fc-timeGridDay-button:hover,
.fc-timeGridWeek-button:hover,
.fc-dayGridMonth-button:hover {
  background-color: #8dc73f !important;
  border-color: #8dc73f !important;
  color: white !important;
}
.fc-prev-button,
.fc-next-button {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  border-color: white !important;
}
.fc-toolbar-title {
  font-size: 24px !important;
}
.fc-header-toolbar {
  background-color: white;
  margin-bottom: 0 !important;
  padding: 5px 10px;
  margin-top: 20px;
  border-radius: 5px;
}
.tutorial-popper {
  white-space: nowrap;
}

@media only screen and (max-width: 800px) {
  .fc-header-toolbar {
    margin-top: 20px;
    font-size: 7px !important;
  }
  .fc-toolbar-title {
    font-size: 20px !important;
  }
  .fc-prev-button {
    font-size: 16px !important;
  }
  .fc-next-button {
    font-size: 16px !important;
  }
}
@media only screen and (max-width: 767px) {
  .fc-header-toolbar {
    margin-top: 10px;
    font-size: 9px;
  }
}
/* .fc-view-harness {
  height: 500px !important;
  background: white;
  margin-top: 10px;
} */
.fc-scrollgrid {
  border-radius: 10px;
}
.trainer-calendar .fc td:nth-of-type(2n + 1),
.fc th {
  border-bottom: 1px solid var(--fc-border-color, #ddd);
}
.fc-col-header-cell {
  background: white !important;
}
.fc-day-past {
  background: #efefef;
}
.trainer-calendar .fc-media-screen .fc-timegrid-event {
  border-width: 1px;
  border-left-width: 5px !important;
  border-radius: 5px !important;
}
.trainer-calendar .fc-header-toolbar {
  border: 1px solid lightgray;
}
.trainer-calendar .fc .fc-button-primary:active:focus {
  box-shadow: unset;
  outline: none;
}
.trainer-calendar .fc .fc-button-primary:focus {
  box-shadow: unset;
  outline: none;
}
.trainer-calendar .fc-timegrid-event .fc-event-main {
  display: flex;
  gap: 4px;
  align-items: center;
  padding-left: 3px;
  padding-right: 3px;
}
.trainer-calendar .fc-timegrid-event .fc-event-main img {
  height: 38px;
  width: 38px;
  border-radius: 5px;
}
.trainer-calendar .fc-v-event .fc-event-main-frame {
  height: max-content;
  overflow: hidden;
}
.trainer-calendar .fc-button-active {
  background-color: #8dc73f !important;
  border-color: #8dc73f !important;
  color: white !important;
}
.trainer-calendar tr .fc-timegrid-slot:nth-of-type(1) {
  border-bottom: none;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.fc-theme-standard td,
.fc-theme-standard th {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
}
</style>